module.exports = __webpack_public_path__ + "static/2-0e6ffb39ce6514fed3e67a509865a999.svg";